import React from 'react'

export default (props: any) => (
  <svg {...props} width="398" height="94" viewBox="0 0 398 94" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="94" height="94">
      <path d="M0.598953 0.505219H93.5V93.4063H0.598953V0.505219Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1_2)">
      <mask id="mask1_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="94" height="94">
        <path
          d="M47.0573 0.526047C21.4479 0.526047 0.619781 21.3542 0.619781 46.9635C0.619781 72.5781 21.4479 93.3906 47.0573 93.3906C72.6719 93.3906 93.4844 72.5625 93.4844 46.9635C93.4844 21.3646 72.6562 0.526047 47.0573 0.526047Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1_2)">
        <path d="M-7.00002 -7.09375H101.104V101.005H-7.00002V-7.09375Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask2_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="17" y="39" width="14" height="16">
      <path d="M17.4896 39.7761H31V54.1354H17.4896V39.7761Z" fill="white" />
    </mask>
    <g mask="url(#mask2_1_2)">
      <mask id="mask3_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="17" y="39" width="14" height="15">
        <path
          d="M25.7865 53.0104L26.0312 52.6927L26.3958 52.2188C27.1302 51.2917 27.7552 50.5157 28.4271 49.7084L28.4688 49.6615L30.9531 46.7657C29.1563 44.4323 27.5885 42.1354 26.1979 39.9271H24.526C22.5885 39.9271 20.9271 40.6094 19.5573 41.9792C18.1875 43.3542 17.5 45.0157 17.5 46.9479C17.5 48.8854 18.1875 50.5573 19.5573 51.9323C20.9271 53.3021 22.5885 53.9896 24.526 53.9896H25.0573L25.2083 53.7761L25.6198 53.2396"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1_2)">
        <path d="M-7 -7.09373H101.104V101.005H-7V-7.09373Z" fill="white" />
      </g>
    </g>
    <mask id="mask4_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="39" y="11" width="16" height="21">
      <path d="M39.026 11.0625H55V31.3333H39.026V11.0625Z" fill="white" />
    </mask>
    <g mask="url(#mask4_1_2)">
      <mask id="mask5_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="39" y="11" width="16" height="20">
        <path
          d="M47.2396 30.8438L47.7916 30.4167L49.3281 29.276C49.7396 28.9844 50.0885 28.724 50.4583 28.4844L50.5156 28.4375L54.3125 25.9375C54.4635 23.6042 54.6302 21.0469 54.8281 17.5729C55.0104 15.6979 54.1719 14.1771 52.3281 12.974C50.7448 11.9531 48.9948 11.4323 47.0573 11.4323C45.125 11.4323 43.3698 11.9375 41.7864 12.974C39.9271 14.1771 39.0885 15.6979 39.2708 17.5729C39.4687 21.0469 39.6562 23.6198 39.8073 25.9531L47.0573 30.9948C47.1198 30.9531 47.1823 30.9063 47.2552 30.8438"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_1_2)">
        <path d="M-7.00003 -7.09375H101.104V101.005H-7.00003V-7.09375Z" fill="white" />
      </g>
    </g>
    <mask id="mask6_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="39" y="63" width="16" height="20">
      <path d="M39.026 63.0052H55V82.6667H39.026V63.0052Z" fill="white" />
    </mask>
    <g mask="url(#mask6_1_2)">
      <mask id="mask7_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="39" y="63" width="16" height="20">
        <path
          d="M44.2239 65.6302L44.1927 65.6615L43.5989 66.1458L43.2344 66.4375C42.4427 67.0937 41.6823 67.6875 40.9479 68.25L40.5989 68.526L39.8073 69.1198C39.5781 71.2031 39.4271 73.4427 39.2552 76.3385C39.1667 78.1979 40.0364 79.724 41.8177 80.9115C43.3698 81.9479 45.1094 82.4635 47.0417 82.4635C48.9792 82.4635 50.6979 81.9479 52.2708 80.9115C54.0677 79.724 54.9219 78.1979 54.8281 76.3385C54.6614 73.4583 54.5104 71.2031 54.3854 69.1927L47.0573 63.2344C46.0989 64.0729 45.1562 64.8802 44.2239 65.6458"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_1_2)">
        <path d="M-7.00002 -7.09375H101.104V101.005H-7.00002V-7.09375Z" fill="white" />
      </g>
    </g>
    <mask id="mask8_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="63" y="39" width="14" height="16">
      <path d="M63.099 39.7761H76.6094V54.1354H63.099V39.7761Z" fill="white" />
    </mask>
    <g mask="url(#mask8_1_2)">
      <mask id="mask9_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="63" y="39" width="14" height="15">
        <path
          d="M66.3177 42.3906L65.875 43.0625L64.8854 44.4792L64.4115 45.1198L63.349 46.5365L63.1771 46.75C65.401 49.3386 67.3542 51.7344 69.0469 53.9896H69.5781C71.5156 53.9896 73.1719 53.3021 74.5469 51.9323C75.9167 50.5573 76.6042 48.9011 76.6042 46.9636C76.6042 45.0313 75.9167 43.3698 74.5469 41.9948C73.1719 40.625 71.5156 39.9375 69.5781 39.9375H67.901C67.474 40.6406 67.0208 41.3281 66.5469 42.0417L66.3802 42.2708"
          fill="white"
        />
      </mask>
      <g mask="url(#mask9_1_2)">
        <path d="M-7 -7.09373H101.104V101.005H-7V-7.09373Z" fill="white" />
      </g>
    </g>
    <mask id="mask10_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="48" y="48" width="27" height="27">
      <path d="M48.3333 48.224H74.9219V74.8281H48.3333V48.224Z" fill="white" />
    </mask>
    <g mask="url(#mask10_1_2)">
      <mask id="mask11_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="48" y="48" width="27" height="27">
        <path
          d="M56.7656 54.0781L48.599 61.849C59.5833 71.4479 66.6354 74.7396 71.1771 74.6771L72.276 74.3906C74.4844 72.1823 74.776 71.0833 74.776 71.0833C74.8333 66.5261 71.526 59.4583 61.8698 48.4115L56.7656 54.0781Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask11_1_2)">
        <path d="M-7 -7.09375H101.104V101.005H-7V-7.09375Z" fill="white" />
      </g>
    </g>
    <mask id="mask12_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="19" y="19" width="27" height="27">
      <path d="M19.1823 19.0886H45.6667V45.2656H19.1823V19.0886Z" fill="white" />
    </mask>
    <g mask="url(#mask12_1_2)">
      <mask id="mask13_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="19" y="19" width="27" height="27">
        <path
          d="M39.9427 37.2448L45.4114 32.3073C32.75 22.6146 19.8333 18.8229 19.375 19.2813C18.9167 19.7344 22.6979 32.5833 32.3385 45.2292L39.9427 37.2604"
          fill="white"
        />
      </mask>
      <g mask="url(#mask13_1_2)">
        <path d="M-7.00002 -7.09373H101.104V101.005H-7.00002V-7.09373Z" fill="white" />
      </g>
    </g>
    <mask id="mask14_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="19" y="19" width="56" height="56">
      <path d="M19.1823 19.0886H74.9219V74.8281H19.1823V19.0886Z" fill="white" />
    </mask>
    <g mask="url(#mask14_1_2)">
      <mask id="mask15_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="19" y="19" width="56" height="56">
        <path
          d="M74.7448 19.2813C74.2083 18.7448 55.8333 24.2604 41.3906 38.7084C24.5833 55.4948 19.25 65.3073 19.3281 71.0834L19.6198 72.1823C21.8281 74.3906 22.9219 74.6771 22.9219 74.6771C28.6979 74.7552 38.5104 69.4375 55.3177 52.6302C69.7448 38.1875 75.276 19.8125 74.7448 19.2813Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask15_1_2)">
        <path d="M-7.00002 -7.09373H101.104V101.005H-7.00002V-7.09373Z" fill="white" />
      </g>
    </g>
    <mask id="mask16_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="390" y="57" width="4" height="4">
      <path d="M390.844 57.0625H393.443V60.5833H390.844V57.0625Z" fill="white" />
    </mask>
    <g mask="url(#mask16_1_2)">
      <mask id="mask17_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="390" y="57" width="4" height="4">
        <path d="M391.891 57.7448H390.995V57.2083H393.37V57.7448H392.469V60.4948H391.875L391.891 57.7448Z" fill="white" />
      </mask>
      <g mask="url(#mask17_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask18_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="394" y="57" width="4" height="4">
      <path d="M394.057 57.2136H397.578V60.5834H394.057V57.2136Z" fill="white" />
    </mask>
    <g mask="url(#mask18_1_2)">
      <mask id="mask19_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="394" y="57" width="4" height="4">
        <path
          d="M396.917 57.224L395.745 59.0625L394.568 57.224H394.073V60.4948H394.63V58.2761L395.755 60.0104L396.87 58.2761V60.4948H397.427V57.224H396.917Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask19_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask20_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="119" y="33" width="20" height="28">
      <path d="M119.24 33.3333H138.531V60.125H119.24V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask20_1_2)">
      <mask id="mask21_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="119" y="33" width="20" height="28">
        <path
          d="M119.328 33.4167H129C133.193 33.4167 136.49 36.2917 136.49 40.2292C136.49 42.8021 135.219 44.7865 133.073 45.5885C136.609 46.2396 138.443 48.8698 138.443 52.2031C138.443 56.7135 134.99 60.0833 130.297 60.0833H119.328V33.4167ZM128.344 44.1719C130.38 44.1719 131.802 42.7865 131.802 40.875C131.802 39.1146 130.38 37.7344 128.38 37.7344H124.13V44.1719H128.344ZM129.495 55.7656C131.906 55.7656 133.677 54.1198 133.677 51.9375C133.677 49.7917 131.943 48.1927 129.458 48.1927H124.13V55.7656H129.495Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask21_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask22_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="170" y="33" width="27" height="28">
      <path d="M170.224 33.3333H196.708V60.125H170.224V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask22_1_2)">
      <mask id="mask23_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="170" y="33" width="27" height="28">
        <path
          d="M181.406 33.4167H185.479L196.651 60.0833H191.589L189.391 54.7604H177.49L175.307 60.0833H170.245L181.406 33.4167ZM187.891 50.8229L183.443 39.9635L178.995 50.8333L187.891 50.8229Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask23_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask24_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="200" y="33" width="22" height="28">
      <path d="M200.688 33.3333H221.667V60.125H200.688V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask24_1_2)">
      <mask id="mask25_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="200" y="33" width="22" height="28">
        <path
          d="M200.823 33.4167H211.234C215.995 33.4167 219.911 37.0573 219.911 41.8802C219.911 45.3958 217.911 48.2656 215.036 49.4531L221.521 60.0833H216.104L210.385 50.5938H205.62V60.0833H200.823V33.4167ZM210.724 46.3125C213.328 46.3125 215.135 44.5104 215.135 41.9531C215.135 39.5052 213.411 37.7448 211.109 37.7448H205.62V46.3125H210.724Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask25_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask26_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="226" y="33" width="25" height="28">
      <path d="M226.411 33.3333H250.141V60.125H226.411V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask26_1_2)">
      <mask id="mask27_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="226" y="33" width="25" height="28">
        <path
          d="M226.526 33.4167H236.089C245.156 33.4167 250.135 39.0052 250.135 46.8125C250.135 54.651 245.182 60.0938 236.125 60.0938H226.526V33.4167ZM235.776 55.7656C242.802 55.7656 245.339 51.901 245.339 46.8125C245.339 41.6146 242.802 37.7448 235.74 37.7448H231.328V55.7656H235.776Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask27_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask28_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="255" y="33" width="22" height="28">
      <path d="M255.5 33.3333H276.323V60.125H255.5V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask28_1_2)">
      <mask id="mask29_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="255" y="33" width="22" height="28">
        <path
          d="M255.531 33.4167H265.943C270.703 33.4167 274.62 37.0573 274.62 41.8802C274.62 45.3958 272.62 48.2656 269.745 49.4531L276.219 60.0833H270.802L265.078 50.5938H260.318V60.0833H255.516L255.531 33.4167ZM265.432 46.3125C268.036 46.3125 269.844 44.5104 269.844 41.9531C269.844 39.5052 268.125 37.7448 265.818 37.7448H260.328V46.3125H265.432Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask29_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask30_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="281" y="33" width="6" height="28">
      <path d="M281.406 33.4167H286.203V60.0834H281.406V33.4167Z" fill="white" />
    </mask>
    <g mask="url(#mask30_1_2)">
      <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
    </g>
    <mask id="mask31_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="293" y="33" width="25" height="28">
      <path d="M293.318 33.3333H317.047V60.125H293.318V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask31_1_2)">
      <mask id="mask32_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="293" y="33" width="24" height="28">
        <path
          d="M293.333 33.4167H302.896C311.958 33.4167 316.953 39.0052 316.953 46.8125C316.953 54.651 311.995 60.0938 302.932 60.0938H293.333V33.4167ZM302.589 55.7656C309.609 55.7656 312.151 51.901 312.151 46.8125C312.151 41.6146 309.62 37.7448 302.552 37.7448H298.141V55.7656H302.589Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask32_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask33_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="321" y="33" width="19" height="28">
      <path
        d="M321.849 33.4167H338.891V37.7448H321.849V33.4167ZM321.849 37.7448H326.651V44.099H321.849V37.7448ZM321.849 44.099H338.125V48.4219H321.849V44.099ZM321.849 48.4219H326.651V55.7656H321.849V48.4219ZM321.849 55.7656H339.167V60.0834H321.849V55.7656Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask33_1_2)">
      <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
    </g>
    <mask id="mask34_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="345" y="33" width="22" height="28">
      <path d="M345.37 33.3333H366.193V60.125H345.37V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask34_1_2)">
      <mask id="mask35_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="345" y="33" width="22" height="28">
        <path
          d="M345.458 33.4531H355.87C360.63 33.4531 364.547 37.0937 364.547 41.9167C364.547 45.4323 362.547 48.3021 359.677 49.4896L366.161 60.1198H360.74L355.021 50.6302H350.26V60.1198H345.458V33.4531ZM355.359 46.349C357.969 46.349 359.771 44.5469 359.771 41.9896C359.771 39.5417 358.052 37.7812 355.75 37.7812H350.26V46.349H355.359Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask35_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask36_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="368" y="33" width="21" height="28">
      <path d="M368.948 33.3333H388.24V60.125H368.948V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask36_1_2)">
      <mask id="mask37_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="369" y="33" width="20" height="28">
        <path
          d="M381.286 44.474L380.229 44.0469C377.057 42.8021 375.698 42.2656 375.698 40.4583C375.698 39.0573 377.042 38.026 378.896 38.026C380.859 38.026 382.266 38.7292 383.198 40.1562L383.344 40.375L387.005 37.8802L386.87 37.6719C385.104 34.9115 382.313 33.4531 378.823 33.4531C374.12 33.4531 370.703 36.4271 370.703 40.5312C370.703 45.25 374.229 46.9583 378.156 48.4219C381.26 49.5885 383.161 50.401 383.161 52.4948C383.161 53.0052 382.969 55.5521 379.125 55.5521C376.391 55.5521 374.208 54.2292 372.984 51.8385L372.859 51.599L369.005 54.0104L369.104 54.2031C370.802 57.9635 374.438 60.1198 379.089 60.1198C384.729 60.1198 388.229 57.1615 388.229 52.3854C388.229 48.0938 385.573 46.1667 381.297 44.4583"
          fill="white"
        />
      </mask>
      <g mask="url(#mask37_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
    <mask id="mask38_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="141" y="33" width="29" height="28">
      <path d="M141.896 33.3333H169.458V60.125H141.896V33.3333Z" fill="white" />
    </mask>
    <g mask="url(#mask38_1_2)">
      <mask id="mask39_1_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="142" y="33" width="28" height="28">
        <path
          d="M155.651 33.4688C148.016 33.4688 142.042 39.3229 142.042 46.8125C142.042 54.276 148.016 60.1198 155.651 60.1198C163.313 60.1198 169.313 54.276 169.313 46.8125C169.313 39.3333 163.313 33.4688 155.651 33.4688ZM155.661 55.4531C150.708 55.4531 146.818 51.6615 146.818 46.8125C146.818 41.9531 150.708 38.1458 155.661 38.1458C160.646 38.1458 164.536 41.9531 164.536 46.8125C164.536 51.6615 160.63 55.4531 155.661 55.4531Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask39_1_2)">
        <path d="M113.271 27.3594H403.547V66.5521H113.271V27.3594Z" fill="#030000" />
      </g>
    </g>
  </svg>
)
